import { render, staticRenderFns } from "./DataCreateInsti.vue?vue&type=template&id=1d6e2a63&scoped=true&"
import script from "./DataCreateInsti.vue?vue&type=script&lang=js&"
export * from "./DataCreateInsti.vue?vue&type=script&lang=js&"
import style0 from "./DataCreateInsti.vue?vue&type=style&index=0&id=1d6e2a63&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e2a63",
  null
  
)

export default component.exports